import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { getCertificates as getCertificatesApi } from 'api/certificates'
import { Certificate } from 'types'
import { RootState } from '../store'

export const getCertificates = createAsyncThunk('getCertificates', async (_, thunkAPI) => {
  try {
    const response = await getCertificatesApi()
    return response.data
  } catch (e) {
    thunkAPI.rejectWithValue([])
  }
})

type CertificatesState = {
  certificates: Certificate[]
  isLoading: boolean
  loadingFailed: boolean
}

export const certificatesSlice = createSlice({
  name: 'certificates',
  initialState: {
    certificates: [],
    isLoading: false,
    loadingFailed: false,
  } as CertificatesState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCertificates.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getCertificates.fulfilled, (state, action) => {
        state.isLoading = false
        state.certificates = action.payload ?? []
        state.loadingFailed = false
      })
      .addCase(getCertificates.rejected, (state) => {
        state.isLoading = false
        state.certificates = []
      })
      .addCase('currentUser/logout', (state) => {
        state.certificates = []
      })
  },
})

export const selectCertificatesSlice = (state: RootState) => state.certificates
